var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmlLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.68 106.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e7835e;}.cls-2{fill:#131313;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SML-logo2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768.46,625.57c-1.65.19-2.18-1.08-3-1.76-9.83-8-20.2-7.78-29.63.81-6.47,5.89-10.19,13.86-15.64,20.5-3,3.68-6.1,7.46-10.81,9.74,0-.8-.28-1.51-.07-1.69,6.83-5.62,10.71-13.39,15.27-20.69,4.25-6.81,9.17-13.06,16.54-16.89a22.18,22.18,0,0,1,26.17,4.2C769,621.62,769,623.46,768.46,625.57Z",
    transform: "translate(-694.1 -561.16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M706.34,575.18c15.84,4.58,28.85.41,39.23-12.16.86-1,1.52-2.82,3.46-1.22,2.2,1.81-.29,2.68-.89,3.43-9.13,11.45-21.06,16.44-35.61,14.43-3.06-.42-3.78.27-3.6,3.09.3,4.64.43,9.29.62,13.94,0,1,1.13,2.41-.92,2.66-1.65.2-2.41-.55-2.51-2.24C705.67,589.84,704.87,582.57,706.34,575.18Z",
    transform: "translate(-694.1 -561.16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M730.59,605.21c-11,0-22,0-33-.05-1.22,0-3.33,1.06-3.5-1.4-.21-3,2.23-1.83,3.56-1.83q33.48-.1,67,0c1.34,0,3.8-1.18,3.77,1.63s-2.47,1.58-3.83,1.59C753.24,605.25,741.92,605.21,730.59,605.21Z",
    transform: "translate(-694.1 -561.16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749.17,666.29c-.63,1.15-1.22,2.35-2.91,1.06-8.39-6.39-15.39-14.13-21.81-22.43-.76-1-.47-1.77.36-2.58a1.2,1.2,0,0,1,2.05.19c6,8.5,13.51,15.49,21.48,22.05A1.68,1.68,0,0,1,749.17,666.29Z",
    transform: "translate(-694.1 -561.16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M709.63,607.68c1.26,0,2.16.25,2.49,1.76a98.76,98.76,0,0,0,8.41,22.69c.67,1.35,1.13,2.62-.37,3.41-1.83,1-2-1-2.58-1.94a93.56,93.56,0,0,1-8.86-23.55C708.18,607.83,708.27,607.81,709.63,607.68Z",
    transform: "translate(-694.1 -561.16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmlLogo2);
export default __webpack_public_path__ + "static/media/SML-logo2.4738ab7607b32e89e9dcc1ae4470965b.svg";
export { ForwardRef as ReactComponent };